import { Pipe, PipeTransform } from '@angular/core';
import { TranslationHelper } from '../helpers/translation-helper'

@Pipe({
  name: 'priceFormat'
})

export class PriceFormatPipe implements PipeTransform {
    constructor(private translateHelper: TranslationHelper) {}
    transform(value: any): any {
            return this.translateHelper.getNumberString(value);
    }

}